import React, { useState } from 'react';
import { IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, Divider } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const reglasPerfiles = [
  { perfil: 'Administrador', desc: 'Acceso total al sistema. Ve datos de todas las sucursales.' },
  { perfil: 'Colaborador', desc: 'Cambios de Precios - Ver todos los pedidos.' },
  { perfil: 'Sucursal', desc: 'Ver pedidos propios de su sucursal.' },
];

const reglasSucursal = [
  'Si el usuario NO tiene una sucursal asignada, ve datos de TODAS las sucursales.',
  'Si el usuario tiene una sucursal asignada, solo ve los datos de esa sucursal.',
];

export default function AyudaButton({ titulo, contenido }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <IconButton onClick={() => setOpen(true)} size="small" sx={{ ml: 1 }}>
        <HelpOutlineIcon fontSize="small" />
      </IconButton>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{titulo || 'Ayuda'}</DialogTitle>
        <DialogContent dividers>
          {contenido || (
            <>
              <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600 }}>Perfiles</Typography>
              {reglasPerfiles.map((r, i) => (
                <Box key={i} sx={{ mb: 1.5 }}>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>{r.perfil}</Typography>
                  <Typography variant="body2" color="text.secondary">{r.desc}</Typography>
                </Box>
              ))}
              <Divider sx={{ my: 2 }} />
              <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600 }}>Regla de Sucursal</Typography>
              {reglasSucursal.map((r, i) => (
                <Typography key={i} variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>• {r}</Typography>
              ))}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cerrar</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
